import { Ti18nKeys } from "../../constants/i18n";
import { ColorsEnum } from "../../core/et3-theme/colors";
import { TReactionAction } from "../../Types";

export const REACTION_BADGE_SIZE = 28;
export const REACTION_BADGE_RADIUS = 8;
export const REACTION_BADGE_GAP = 6;
export const REACTION_EMOJI_FONT_SIZE = 18;

// Separates the reaction footer from the message text inside a report bubble,
// which already has a coloured background.
export const REACTION_DIVIDER_COLOR = "#FFFFFF66";

export const HISTORY_ICON_SIZE = 20;
export const HISTORY_ROW_HEIGHT = 42;
export const HISTORY_LIST_MAX_HEIGHT = 420;
export const HISTORY_POPUP_WIDTH = 890;
// Wider when both users reacted, so each of the two panels still fits a row.
export const HISTORY_POPUP_WIDTH_SPLIT = 1240;
export const HISTORY_POPUP_RADIUS = 28;
export const HISTORY_PANEL_HEADER_HEIGHT = 46;
export const HISTORY_TIMESTAMP_WIDTH = 220;
export const HISTORY_TIMESTAMP_WIDTH_SPLIT = 160;

const ALPHA_SCRIM = "8A";
export const HISTORY_SCRIM = `${ColorsEnum.maastrichtBlue}${ALPHA_SCRIM}`;
export const HISTORY_SCRIM_BLUR = "blur(3px)";
// Below Et3Loading's 200 so the loading overlay still wins.
export const HISTORY_Z_INDEX = 150;
export const HISTORY_TRANSITION_MS = 220;
export const HISTORY_CARD_SHADOW = "0 18px 48px rgba(13, 31, 60, 0.28)";

export const REACTION_ACTION_KEYS: { [key in TReactionAction]: Ti18nKeys } = {
  ADDED: "REACTION_ADDED",
  CHANGED: "REACTION_CHANGED",
  REMOVED: "REACTION_REMOVED"
};
